/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import { Breakpoints } from 'constants/Breakpoints';
import { Text } from 'components/Text';
import { FiraSansExtraLight } from 'components/Text/Text';
import Label from 'components/Form/Label';
import Colors from 'constants/Colors';

export const ButtonContent = styled.div`
  display:flex;
  flex-direction: row;
  justify-content:space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 15px;
    width: 100%;
  }
`;

export const FieldText = styled(Text)`
  font-size: ${(props) => (props.size ? `${props.size}px` : "14px")};
  font-weight: ${(props) => (props.bold ? `bold` : "normal")};
  color: #53565a;
  display: block;
  padding: 3px 0;
`;

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  span {
    font-size: 13px !important;
  }
`
export const TableRow = styled.tr`
  ${({ error }) => error && 'background: #fddede' }
`;

export const TableBody = styled.tbody`
    tr {
      border-bottom: 2px solid #E0E0E0;
    }
`;

export const TableColumn = styled.td`
  vertical-align: top;
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const LabelEdit = styled(Label)`

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  } 
  
`;

const dragActive = css`
  border-color: ${Colors.PURPLE};
  color: ${Colors.PURPLE};
`;

const dragReject = css`
  border-color: ${Colors.DANGER};
  color: ${Colors.DANGER};
`;

export const DropzoneContainer = styled.div.attrs({
  className: "dropzone"
})`
  width: 100%;
  padding: 10px;
  border: 3px dashed ${Colors.GRAY[0]};
  border-radius: 8px;
  min-height: 150px;
  color: ${Colors.GRAY[0]};
  ${props => props.isDragActive && dragActive};
  ${props => props.isDragReject && dragReject};
  ${FiraSansExtraLight}
  display: flex;
  justify-content: center;
  align-items: center;
`

const messageColors = {
  default: Colors.GRAY[0],
  error: Colors.DANGER,
  success: Colors.PURPLE
};

export const UploadMessage = styled.p`
  display: flex;
  color: ${props => messageColors[props.type || "default"]};
  justify-content: center;
  align-items: center;
  padding: 15px 0;
`;